<template>
  <div class="gc-index-wrap">
    <van-nav-bar :border="false" title="我的"/>
    <div class="gc-index-top-wrap">
      <div class="user-info">
        <img :src="info.pic" alt=""/>
        <div class="info">
          <div class="t">{{ info.name }}</div>
          <p>{{ info.GovDepItem }}&emsp;{{ info.GovDepWorkItem }}</p>
        </div>
      </div>
      <div class="icon-msg">
        <router-link tag="i" class="i2" :to="{ name: 'Info' }"></router-link>
        <router-link tag="i" class="i3" :to="{ name: 'Setting' }"></router-link>
      </div>
    </div>
    <div class="gc-my-short-wrap">
      <!-- <router-link tag="div" class="item" :to="{name:'Cost'}"><i class="i1"></i><p>个人成本</p></router-link> -->
      <router-link v-if="canMail" tag="div" class="item" :to="{ name: 'Mail' }"
      >
        <van-icon class="i2" name="contact"/>
        <p>通讯录</p></router-link
      >
      <router-link v-if="canDuty" tag="div" class="item" :to="isBoss ? { name: 'Duty', query: { mode: 'boss' } } : { name: 'Duty' }"
      >
        <van-icon class="i3" name="description"/>
        <p>岗位职责</p></router-link
      >
      <router-link
        v-if="canStructure"
        tag="div"
        class="item"
        :to="{ name: 'Structure' }"
      >
        <van-icon class="i4" name="cluster-o"/>
        <p>组织架构</p></router-link
      >
      <!-- <a class="item" v-if="hasCrmURL" :href="crmURL"><i class="i5"></i><p>CRM</p></a> -->
      <a v-if="canSurvey360" class="item" :href="testURL"
      >
        <van-icon class="i6" name="todo-list-o"/>
        <p>360测评</p></a
      >
      <router-link v-if="canLog" tag="div" class="item" :to="{ name: 'EfficiencyHistory' }"
      >
        <van-icon class="i7" name="records"/>
        <p>日志管理</p></router-link
      >
      <router-link v-if="crmUserId && canCustomer" tag="div" class="item" :to="{ name: 'BossCustomerData' }"
      >
        <van-icon class="i8" name="gold-coin-o"/>
        <p>客户管理</p></router-link
      >
    </div>
    <!-- 管理中心：仅对有身份/权限管理权限的用户显示 -->
    <section v-if="hasAdminAccess" class="admin-panel">
      <header>
        <h2>管理中心</h2>
      </header>
      <div class="gc-my-short-wrap admin-short">
        <router-link v-if="canReadCatalog" tag="div" class="item" to="/boss/identity/permissions">
          <van-icon name="shield-o"/>
          <p>权限目录</p></router-link>
        <router-link v-if="canManageRoles" tag="div" class="item" to="/boss/identity/roles">
          <van-icon name="friends-o"/>
          <p>角色管理</p></router-link>
      </div>
    </section>
    <section v-if="false" class="acceptance-panel">
      <header>
        <div><h2>功能验收身份</h2>
          <p>当前：{{ acceptanceRoleLabel }}</p></div>
        <van-icon name="setting-o"/>
      </header>
      <p class="acceptance-tip">按员工提交、主管复核、Boss 查看汇总的顺序测试。验收身份数据相互关联，但与真实账号隔离；Boss
        下发任务后，请切回对应“员工岗位”查看。</p>
      <div class="acceptance-actions">
        <button @click="showEmployeePositions = true">
          <van-icon name="contact"/>
          <span>员工岗位</span></button>
        <button @click="switchAcceptanceRole('SUPERVISOR')">
          <van-icon name="manager-o"/>
          <span>主管端</span></button>
        <button @click="switchAcceptanceRole('BOSS')">
          <van-icon name="bar-chart-o"/>
          <span>Boss端</span></button>
      </div>
      <button class="restore-role" @click="restoreRealIdentity">退出验收，恢复真实身份</button>
    </section>
    <div v-if="showEmployeePositions" class="position-mask" @click.self="showEmployeePositions = false">
      <section class="position-sheet" role="dialog" aria-modal="true" aria-label="选择员工岗位">
        <header class="position-sheet-title">
          <div><h3>选择员工岗位</h3>
            <p>各岗位使用独立验收数据</p></div>
          <button aria-label="关闭" @click="showEmployeePositions = false">
            <van-icon name="cross"/>
          </button>
        </header>
        <button v-for="position in employeePositions" :key="position.family" class="position-option" @click="switchEmployeePosition(position)">
          <span class="position-icon"><van-icon :name="position.icon"/></span>
          <span class="position-copy"><strong>{{ position.positionName }}</strong><small>{{ position.departmentName }}</small></span>
          <van-icon name="arrow"/>
        </button>
      </section>
    </div>
    <div class="my-text-wrap">
      <div class="title">
        敬湘缘
      </div>
      <div class="content">
        <p>楚江潮涌竞千帆，</p>
        <p>湘雨泼墨染青峦。</p>
        <p>汇得天地英雄气，</p>
        <p>中华掌中化龙蟠。</p>
      </div>
    </div>
    <div class="my-text-wrap">
      <div class="title">
        密蜜
      </div>
      <div class="content">
        <p>福泽京城润中华，</p>
        <p>建筑中国长寿村。</p>
        <p>康乐山水养精神，</p>
        <p>养老华夏悦人生。</p>
      </div>
    </div>
    <div class="my-text-wrap">
      <div class="title">
        庆朝华
      </div>
      <div class="content">
        <p>健康的事业，是对生命的敬畏。</p>
        <p>让我们一起携手，</p>
        <p>持正念、结正果，</p>
        <p>以自己健康为根，以家庭健康为本，</p>
        <p>我们一起跨过人生的百年！</p>
      </div>
    </div>
    <div class="my-text-wrap">
      <div class="title">
        婉辞
      </div>
      <div class="content">
        <p>不知祥云衬明月，</p>
        <p>负重前行倡健康。</p>
        <p>朝霞满堂惜炎日，</p>
        <p>华彩几度续篇章。</p>
      </div>
    </div>
    <div class="my-text-wrap">
      <div class="title">
        自强不息，厚德载物。
      </div>
      <div class="content">
        <p>
          源自《周易》，其中“自强不息”出自《周易·乾卦》的“天行健，君子以自强不息”，寓意不断奋发进取；
        </p>
        <p>
          “厚德载物”则出自《周易·坤卦》的“地势坤，君子以厚德载物”，强调包容万物的品德。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 「我的」页：legacy 用户信息 + 快捷入口。
 * 含功能验收身份切换（员工岗位/主管/Boss），与真实账号 localStorage 隔离。
 */
import coreapi from "@/utils/coreapi";
import { hasPerm, getRoleCodes } from '@/utils/perm';

export default {
  data() {
    return {
      info: {
        name: "",
        GovDepItem: "",
        GovDepWorkItem: ""
      }, hasCrmURL:
        localStorage.getItem("GovDepSysno") == "DP00102" ||
        localStorage.getItem("isBoss") == 1 ||
        localStorage.getItem("GovDepSysno") == "DP00101",
      crmURL:
        "http://lys.hao-xiansheng.com/unitcrm/web/index.html#/?UserSysno=" +
        localStorage.getItem("UserSysno") +
        "&GovDepSysno=" +
        localStorage.getItem("GovDepSysno") +
        "&ReponseLog=" +
        localStorage.getItem("ReponseLog") +
        "&IsBoss=" +
        localStorage.getItem("isBoss"),
      testURL:
        "http://lys.hao-xiansheng.com/unitscorem/weba/index.html#/?UserSysno=" +
        localStorage.getItem("UserSysno"),
      testURL2:
        "http://lys.hao-xiansheng.com/unitscorem/webm/index.html#/?UserSysno=" +
        localStorage.getItem("UserSysno"),
      showAcceptance: false,
      acceptanceRole: localStorage.getItem("CoreAcceptanceRole") || "REAL",
      acceptancePositionName: localStorage.getItem("CoreAcceptancePositionName") || "",
      showEmployeePositions: false,
      employeePositions: [
        {
          suffix: "SALES",
          employeeName: "张建（销售验收）",
          departmentKey: "DP-SALES",
          departmentName: "销售部",
          positionName: "销售",
          family: "SALES",
          icon: "balance-list-o"
        },
        {
          suffix: "REHAB",
          employeeName: "张建（店长验收）",
          departmentKey: "DP-REHAB",
          departmentName: "康复中心",
          positionName: "康复中心店长",
          family: "REHAB_MANAGER",
          icon: "shop-o"
        },
        {
          suffix: "COUNSELOR",
          employeeName: "张建（心理咨询师验收）",
          departmentKey: "DP-REHAB",
          departmentName: "康复中心",
          positionName: "心理咨询师",
          family: "PSYCHOLOGICAL_COUNSELOR",
          icon: "smile-comment-o"
        },
        {
          suffix: "THERAPIST",
          employeeName: "张建（推拿理疗师验收）",
          departmentKey: "DP-REHAB",
          departmentName: "康复中心",
          positionName: "推拿理疗师",
          family: "MASSAGE_THERAPIST",
          icon: "like-o"
        },
        {
          suffix: "TRAINING",
          employeeName: "张建（网培管理验收）",
          departmentKey: "DP-TRAINING",
          departmentName: "网培部",
          positionName: "网培管理岗",
          family: "TRAINING_MANAGER",
          icon: "friends-o"
        },
        {
          suffix: "FINANCE",
          employeeName: "张建（财务验收）",
          departmentKey: "DP-GM-OFFICE",
          departmentName: "总经办",
          positionName: "财务",
          family: "FINANCE",
          icon: "gold-coin-o"
        },
        {
          suffix: "FRONT",
          employeeName: "张建（前台验收）",
          departmentKey: "DP-GM-OFFICE",
          departmentName: "总经办",
          positionName: "公司前台",
          family: "FRONT_DESK",
          icon: "service-o"
        }
      ]
    };
  },
  computed: {
    acceptanceRoleLabel() {
      if (this.acceptanceRole === "EMPLOYEE") return `员工端 · ${this.acceptancePositionName || "请选择岗位"}`;
      return {SUPERVISOR: "张建（主管验收）", BOSS: "张建（Boss验收）", REAL: "真实身份"}[this.acceptanceRole] || "真实身份";
    },
    isBoss() {
      return localStorage.getItem("isBoss") == 1
        || localStorage.getItem("CoreIsBoss") === "true";
    },
    crmUserId() {
      return localStorage.getItem("CrmUserId") || "";
    },
    /** 角色标签显示（从共享工具读） */
    adminRoleLabel() {
      const roles = getRoleCodes();
      if (!roles.length) return '管理员';
      const CODE_LABEL = {
        TENANT_ADMIN: '租户管理员',
        SYSTEM_ADMIN: '系统管理员',
        OPERATIONS_ADMIN: '运营管理员',
        HR_ADMIN: '人事管理员',
        FINANCE_REVIEWER: '财务审核员',
        SUPERVISOR: '主管'
      };
      const labels = roles.map(r => CODE_LABEL[r] || r);
      return labels.join(' · ') || '管理员';
    },
    /** 以下权限判断全部用共享 hasPerm（内部已实现 manage 覆盖 read 规则） */
    canReadCatalog() {
      return hasPerm('system.config.read', 'system.audit.read',
          'identity.role.read', 'identity.employee.read', 'identity.organization.read',
          'boss.dashboard.read');
    },
    canManageRoles() {
      return hasPerm('identity.role.read');
    },
    /** 是否显示"管理中心"整块（有任一管理权限就显示） */
    hasAdminAccess() {
      return this.canReadCatalog || this.canManageRoles;
    },
    // —— 我的Tab 功能入口权限（legacy 页面同样纳入 RBAC 管控）——
    canMail() {
      return hasPerm('identity.mail.read');
    },
    canDuty() {
      return hasPerm('kpi.duty.read');
    },
    canStructure() {
      return hasPerm('identity.organization.read');
    },
    canSurvey360() {
      return hasPerm('evaluation.survey360.read');
    },
    canLog() {
      return hasPerm('efficiency.worklog.read');
    },
    canCustomer() {
      return hasPerm('boss.customer.read');
    }
  },
  mounted() {
    this.WebGetGovUserLst();
  },
  methods: {
    switchEmployeePosition(position) {
      this.showEmployeePositions = false;
      return this.activateAcceptanceProfile("EMPLOYEE", {
        suffix: `EMP-${position.suffix}`,
        employeeName: position.employeeName,
        departmentKey: position.departmentKey,
        departmentName: position.departmentName,
        positionName: position.positionName,
        positionFamily: position.family,
        supervisor: false,
        route: "Efficiency"
      });
    },
    async switchAcceptanceRole(role) {
      const realUser = localStorage.getItem("UserSysno") || "ZHANGJIAN";
      const realTenant = localStorage.getItem("UserComSysno") || "OKR-DEMO-COMPANY";
      const departmentKey = localStorage.getItem("GovDepSysno") || "DP-SAFE";
      const departmentName = this.info.GovDepItem || localStorage.getItem("CoreDepartmentName") || "安全事业部";
      const profiles = {
        SUPERVISOR: {
          suffix: "SUP",
          employeeName: "张建（主管验收）",
          positionName: "销售主管",
          positionFamily: "SALES",
          supervisor: true,
          route: "SupervisorHome"
        },
        BOSS: {
          suffix: "BOSS",
          employeeName: "张建（Boss验收）",
          departmentKey: "HQ",
          departmentName: "总部",
          positionName: "总负责人",
          positionFamily: "GENERAL_MANAGER",
          supervisor: true,
          route: "Home"
        }
      };
      const profile = profiles[role];
      return this.activateAcceptanceProfile(role, profile, {realUser, realTenant, departmentKey, departmentName});
    },
    /**
     * 写入验收专用 UserId/TenantId 并 synchronize，使全效后端创建隔离的验收数据。
     * 首次切换时备份 CoreRealIsBoss / CoreRealIsTop 供恢复。
     */
    async activateAcceptanceProfile(role, profile, identityDefaults) {
      const defaults = identityDefaults || {};
      const realUser = defaults.realUser || localStorage.getItem("UserSysno") || "ZHANGJIAN";
      const realTenant = defaults.realTenant || localStorage.getItem("UserComSysno") || "OKR-DEMO-COMPANY";
      const departmentKey = defaults.departmentKey || localStorage.getItem("GovDepSysno") || "DP-SAFE";
      const departmentName = defaults.departmentName || this.info.GovDepItem || localStorage.getItem("CoreDepartmentName") || "安全事业部";
      const activeDepartmentKey = profile.departmentKey || departmentKey;
      const activeDepartmentName = profile.departmentName || departmentName;
      if (!localStorage.getItem("CoreAcceptanceUserId")) {
        localStorage.setItem("CoreRealIsBoss", localStorage.getItem("isBoss") || "0");
        localStorage.setItem("CoreRealIsTop", localStorage.getItem("isTop") || "0");
      }
      localStorage.setItem("CoreAcceptanceUserId", `${realUser}-ACCEPT-${profile.suffix}`);
      localStorage.setItem("CoreAcceptanceTenantId", `${realTenant}-ACCEPTANCE`);
      localStorage.setItem("CoreAcceptanceRole", role);
      if (role === "EMPLOYEE") localStorage.setItem("CoreAcceptancePositionName", profile.positionName);
      else localStorage.removeItem("CoreAcceptancePositionName");
      localStorage.setItem("CoreEmployeeName", profile.employeeName);
      localStorage.setItem("CoreDepartmentKey", activeDepartmentKey);
      localStorage.setItem("CoreDepartmentName", activeDepartmentName);
      localStorage.setItem("CorePositionName", profile.positionName);
      localStorage.setItem("CorePositionFamily", profile.positionFamily);
      localStorage.setItem("CoreSupervisor", String(profile.supervisor));
      localStorage.setItem("isTop", profile.supervisor ? "1" : "0");
      localStorage.setItem("isBoss", role === "BOSS" ? "1" : "0");
      try {
        await coreapi.synchronize({
          employeeName: profile.employeeName,
          departmentKey: activeDepartmentKey,
          departmentName: activeDepartmentName,
          positionName: profile.positionName,
          positionFamily: profile.positionFamily,
          supervisor: profile.supervisor
        });
        this.acceptanceRole = role;
        this.acceptancePositionName = role === "EMPLOYEE" ? profile.positionName : "";
        this.$toast.success(`已切换到${this.acceptanceRoleLabel}`);
        this.$router.push({name: profile.route});
      } catch (error) {
        this.$toast.fail(error.message);
      }
    },
    /** 退出验收：清除隔离 ID，恢复 legacy isBoss/isTop 与真实岗位缓存 */
    async restoreRealIdentity() {
      localStorage.removeItem("CoreAcceptanceUserId");
      localStorage.removeItem("CoreAcceptanceTenantId");
      localStorage.removeItem("CoreAcceptanceRole");
      localStorage.removeItem("CoreAcceptancePositionName");
      localStorage.removeItem("CoreDepartmentKey");
      const positionName = this.info.GovDepWorkItem || "销售";
      const positionFamily = this.inferCorePositionFamily(positionName);
      localStorage.setItem("CoreEmployeeName", this.info.name || "张建");
      localStorage.setItem("CoreDepartmentName", this.info.GovDepItem || "安全事业部");
      localStorage.setItem("CorePositionName", positionName);
      localStorage.setItem("CorePositionFamily", positionFamily);
      localStorage.removeItem("CoreSupervisor");
      localStorage.setItem("isBoss", localStorage.getItem("CoreRealIsBoss") || "0");
      localStorage.setItem("isTop", localStorage.getItem("CoreRealIsTop") || "0");
      localStorage.removeItem("CoreRealIsBoss");
      localStorage.removeItem("CoreRealIsTop");
      this.acceptanceRole = "REAL";
      this.acceptancePositionName = "";
      this.$toast.success("已恢复真实身份");
      this.$router.push({name: "Home"});
    },
    inferCorePositionFamily(name) {
      const value = (name || "").toLowerCase();
      if (value.indexOf("总负责人") >= 0 || value.indexOf("董事长") >= 0 || value.indexOf("老板") >= 0 || value === "boss") return "GENERAL_MANAGER";
      if (value.indexOf("全栈") >= 0 || value.indexOf("全端开发") >= 0) return "FULL_STACK";
      if (value.indexOf("销售") >= 0 || value.indexOf("招商") >= 0 || value.indexOf("招生") >= 0) return "SALES";
      if (value.indexOf("品牌") >= 0 || value.indexOf("运营") >= 0) return "BRAND";
      if (value.indexOf("店长") >= 0) return "REHAB_MANAGER";
      if (value.indexOf("心理") >= 0) return "PSYCHOLOGICAL_COUNSELOR";
      if (value.indexOf("推拿") >= 0 || value.indexOf("理疗") >= 0) return "MASSAGE_THERAPIST";
      if (value.indexOf("财务") >= 0 || value.indexOf("会计") >= 0) return "FINANCE";
      if (value.indexOf("前台") >= 0 || value.indexOf("接待") >= 0) return "FRONT_DESK";
      if (value.indexOf("管理") >= 0) return "TRAINING_MANAGER";
      return "GENERAL";
    },
    WebGetGovUserLst() {
      let data = {
        UserSysno: localStorage.getItem("UserSysno")
      };
      this.$baseajax.normalJsonp(
        this.$base.baseapi + "/WebGetGovUserLst",
        data,
        res => {
          console.log(res);
          res = res.WebGetGovUserLstResult;
          if (res.ResponseCode == 1 && res.Item && res.Item.Item && res.Item.GovDepItem && res.Item.GovDepWorkItem) {
            // this.info = res.Item
            this.info.name = res.Item.Item.Name || "";
            this.info.GovDepItem = res.Item.GovDepItem.Name || "";
            this.info.GovDepWorkItem = res.Item.GovDepWorkItem.Name || "";
            if (this.acceptanceRole === "REAL") {
              localStorage.setItem("CoreEmployeeName", this.info.name);
              localStorage.setItem("CoreDepartmentName", this.info.GovDepItem);
              localStorage.setItem("CorePositionName", this.info.GovDepWorkItem);
              localStorage.setItem("CorePositionFamily",
                this.inferCorePositionFamily(this.info.GovDepWorkItem));
            }
            this.info.pic = res.Item.Item.HeadImgUrl
              ? res.Item.Item.HeadImgUrl
              : "../../assets/avatar.png";

            this.crmURL =
              "http://lys.hao-xiansheng.com/unitcrm/web/index.html#/?UserSysno=" +
              localStorage.getItem("UserSysno") +
              "&UserName=" +
              res.Item.Item.Name +
              "&ReponseLog=" +
              localStorage.getItem("ReponseLog") +
              "&IsBoss=" +
              localStorage.getItem("isBoss") +
              "&GovDepSysno=" +
              localStorage.getItem("GovDepSysno");
            this.testURL =
              "http://lys.hao-xiansheng.com/unitscorem/weba/index.html#/?UserSysno=" +
              localStorage.getItem("UserSysno") +
              "&UserName=" +
              res.Item.Item.Name;
            this.testURL2 =
              "http://lys.hao-xiansheng.com/unitscorem/webm/index.html#/?UserSysno=" +
              localStorage.getItem("UserSysno") +
              "&UserName=" +
              res.Item.Item.Name;
          }
        },
        err => {
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/base.less";

.van-nav-bar {
  background: none;
}

.gc-index-wrap {
  background-image: linear-gradient(135deg, #D32F2F 0%, #1A1A1A 100%);
  background-size: 100% 5.8rem;
  background-repeat: no-repeat;
  padding-bottom: 1.6rem;
}

.admin-panel {
  margin: 0.28rem;
  padding: 0.4rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.28rem;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 0.28rem;

    h2 {
      font-size: 0.4rem;
      color: #333333;
      margin: 0;
      display: flex;
      align-items: center;

      &:before {
        content: '';
        width: 0.08rem;
        height: 0.3rem;
        margin-right: 0.12rem;
        background-color: #D32F2F;
      }
    }
  }

  .admin-badge {
    font-size: 0.24rem;
    color: #D32F2F;
    background: #fff5f5;
    padding: 0.06rem 0.16rem;
    border-radius: 0.16rem;
    font-weight: 600;
  }

  .admin-short {
    box-shadow: none;
    padding: 0.2rem 0.1rem;
    background-color: transparent;
  }
}

.acceptance-panel {
  margin: .28rem;
  padding: .36rem;
  background: #fff;
  border-radius: .27rem;
  box-shadow: 0 0 .28rem rgba(211, 47, 47, .14)
}

.acceptance-panel header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: @color;
  font-size: .46rem
}

.acceptance-panel h2 {
  color: #333;
  font-size: .38rem
}

.acceptance-panel header p {
  margin-top: .06rem;
  color: #8a8da3;
  font-size: .26rem
}

.acceptance-tip {
  margin: .24rem 0;
  color: #777b90;
  font-size: .26rem;
  line-height: 1.55
}

.acceptance-actions {
  display: grid;
  grid-template-columns:repeat(3, 1fr);
  gap: .14rem
}

.acceptance-actions button {
  height: 1rem;
  color: @color;
  background: #fff5f5;
  border-radius: .16rem;
  font-size: .28rem
}

.acceptance-actions .van-icon {
  display: block;
  margin-bottom: .07rem;
  font-size: .34rem
}

.restore-role {
  width: 100%;
  height: .72rem;
  margin-top: .18rem;
  color: #777b90;
  border: 1PX solid #e3e4ee;
  border-radius: .14rem;
  background: #fff;
  font-size: .26rem
}

.position-mask {
  position: fixed;
  z-index: 2000;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(24, 27, 49, .42)
}

.position-sheet {
  width: 100%;
  max-width: 750PX;
  padding: .36rem .28rem calc(.28rem + env(safe-area-inset-bottom));
  border-radius: .28rem .28rem 0 0;
  background: #fff;
  box-shadow: 0 -.12rem .4rem rgba(28, 33, 88, .14)
}

.position-sheet-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 .04rem .22rem;
  border-bottom: 1PX solid #eeeef5
}

.position-sheet-title h3 {
  color: #26283a;
  font-size: .36rem;
  line-height: 1.4
}

.position-sheet-title p {
  margin-top: .04rem;
  color: #9497aa;
  font-size: .24rem
}

.position-sheet-title button {
  width: .68rem;
  height: .68rem;
  color: #777b90;
  border: 0;
  border-radius: 50%;
  background: #f4f5fa;
  font-size: .32rem
}

.position-option {
  display: flex;
  align-items: center;
  width: 100%;
  height: 1.05rem;
  padding: 0 .08rem;
  border: 0;
  border-bottom: 1PX solid #f0f0f5;
  background: #fff;
  text-align: left
}

.position-option:active {
  background: #f7f8ff
}

.position-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: .7rem;
  height: .7rem;
  margin-right: .22rem;
  color: @color;
  border-radius: .14rem;
  background: #eff0ff;
  font-size: .34rem
}

.position-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0
}

.position-copy strong {
  color: #303244;
  font-size: .3rem;
  font-weight: 600
}

.position-copy small {
  margin-top: .05rem;
  color: #989bad;
  font-size: .23rem
}

.position-option > .van-icon {
  color: #b7b9c7;
  font-size: .28rem
}

.gc-index-top-wrap {
  padding: 0.5rem 0.28rem;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  .user-info {
    display: flex;
    align-items: center;

    img {
      width: 1.9rem;
      height: 1.9rem;
      border-radius: 100%;
      margin-right: 0.4rem;
      object-fit: cover;
    }

    .info {
      font-size: 0.32rem;
      color: #ffffff;
    }

    .t {
      font-size: 0.48rem;
    }
  }

  .icon-msg {
    position: relative;
    display: flex;

    i {
      margin-left: 0.3rem;
    }

    .i2 {
      display: block;
      width: 0.5rem;
      height: 0.5rem;
      background-image: url("~@/assets/edit.png");
      background-size: contain;
    }

    .i3 {
      display: block;
      width: 0.5rem;
      height: 0.5rem;
      background-image: url("~@/assets/setting.png");
      background-size: contain;
    }

    em {
      position: absolute;
      top: -0.1rem;
      right: -0.1rem;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 100%;
      background-color: #D32F2F;
    }
  }
}

.gc-my-short-wrap {
  margin-left: 0.28rem;
  margin-right: 0.28rem;
  // padding: .5rem;
  padding: 0.5rem 0.2rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;
  display: flex;
  justify-content: space-around;
  font-size: 0.27rem;
  color: @color;
  font-weight: 700;
  text-align: center;

  .item {
    color: @color;
  }

  .van-icon {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 0.9rem;
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.58rem;
    color: @color;
    background: #fff5f5;
    border-radius: 50%;
    margin-bottom: 0.1rem;
    transition: transform .2s ease, background .2s ease;
  }

  .item:active .van-icon {
    transform: scale(0.95);
    background: #ffebee;
  }
}

.my-text-wrap {
  margin: 0.28rem 0.28rem 0;
  padding: 0.48rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .title {
    font-size: 0.4rem;
    color: #333333;
    margin-bottom: 0.4rem;
    padding-bottom: 0.4rem;
    border-bottom: 1px solid #eee;
  }

  .content {
    font-size: 0.28rem;
    line-height: 0.55rem;
    color: #999999;

    p {
      display: flex;

      span {
        font-size: 0.32rem;
        color: #666666;
        margin-right: 0.4rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/My.vue